import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { Config } from 'src/app/models/configuration.model';
import { ContentService } from 'src/app/services/content.service';
import { DrawingService } from 'src/app/services/drawing.service';
import { MultimodalService } from 'src/app/services/multimodal.service';


@Component({
  selector: 'app-frontpage',
  templateUrl: './frontpage.component.html',
  styleUrls: ['./frontpage.component.css']
})
export class FrontpageComponent implements OnInit {

  projects = [];

  config: Config;

  data: any;

  constructor(@Inject(DOCUMENT) private document: Document, private contentService: ContentService,
              private multimodalService: MultimodalService, private drawingService: DrawingService) {
    this.config = this.multimodalService.config;
    this.config.activePage = 'welcome';
  }

  ngOnInit() {
    this.contentService.getSelectedProjects().subscribe(res => {
      this.data = res;
    });
    this.drawingService.mode = this.config.theme;
    this.drawingService.draw();
  }

  scrollDown() {
    this.document.getElementById('page-wrapper').scrollTop = window.innerHeight;
  }

  // @HostListener('window:scroll', ['$event'])
  // onWindowScroll(e: any) {
  //   if (this.config.scrollImageVisible && window.pageYOffset > 200) {
  //     this.config.scrollImageVisible = false;
  //     this.document.getElementById('scroll-msg').classList.add('hidden');
  //   }
  // }

  @HostListener('mousemove', ['$event'])
  onMousemove(e: MouseEvent) {
    if (this.config.modalities[1].active) {
      this.drawingService.moveEye(e.clientX, e.clientY);
    }
  }

  @HostListener('touchmove', ['$event'])
  onTouchMove(e: TouchEvent) {
    if (this.config.modalities[1].active) {
      this.drawingService.moveEye(e.touches[0].clientX, e.touches[0].clientY);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.drawingService.draw(false);
  }

}
